export const MODULE = {
  GET_REPORT: 'getReport',
  GET_REPORT_PRO: 'getReportPro',
  PLAN_ACTION: 'planAction',
  USER_ADMIN: 'userAdmin',
  DASHBOARD: 'dashboard',
  FOLLOW_UP_INSPIRATIONS: 'followUpInspirations',
  FOLLOW_UP: 'followUp',
  FOLLOW_UP_ACTION: 'followUpAction',
  WIDGET_VIEW: 'widgetView',
};
Object.freeze(MODULE);

export enum PAGE_TYPES {
  TERMS = 1,
  IMPRINT = 2,
  CONTACT = 3,
  DATA_PROTECTION = 4,
  CHATBOT_TERMS = 5,
}
